(function ($) {
  $(document).ready(function () {
    var $seeMore = $('.see-more .blog-posts');
    if ($seeMore.length) {
      console.log('hi');
      $seeMore.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        responsive: [{
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 500,
          settings: {
            slidesToShow: 1
          }
        }]
      });
    }
  });
})(jQuery);